module.exports = __webpack_public_path__ + "img/7.5e874437.jpg";